import { Switch } from "@headlessui/react";
import { TooltipCircle } from "components/tooltipCircle";
import { Fragment } from "react";

interface SwitchButtonProps {
  label?: string;
  checked: boolean;
  disabled?: boolean;
  hint?: string;
  onChange: (isChecked: boolean) => void;
}

export const SwitchButton = ({ label, checked, disabled = false, hint, onChange }: SwitchButtonProps) => {
  return (
    <Switch checked={checked} onChange={onChange} disabled={disabled} as={Fragment}>
      {({ checked } : {checked: boolean}) => (
        <div className="w-fit flex items-center gap-x-2">
          <button
            type="button"
            className={`${
              disabled ? checked ? "bg-[#027DEF] opacity-40" : "bg-[#C5CCD2] opacity-40" 
              : checked ? 'bg-brand-500' : 'bg-[#BFBFBF]'
            } relative inline-flex h-6 w-11 items-center rounded-full shrink-0`}
          >
            <span className="sr-only">Is Enabled</span>
            <span
              className={`${
                checked ? 'translate-x-6' : 'translate-x-1'
              } inline-block h-4 w-4 transform rounded-full bg-white transition`}
            />
          </button>
          {label ? <p className="text-sm">{label}</p> : <></>}
          {hint ? <TooltipCircle text={hint} /> : <></>}
        </div>
      )}
    </Switch>
  )
}